import React from "react";
import { Sparkles } from "lucide-react";
import { cn } from "../cn";

export type AiBadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  /**
   * The visible label. Required, and deliberately not optional: the spectrum on
   * its own would make provenance a colour-only signal, which fails WCAG 1.4.1
   * and — more to the point — is unreadable to a therapist who does not already
   * know the convention.
   */
  label: string;
  size?: "sm" | "md";
};

/**
 * Marks content as authored by Alchely rather than by the therapist.
 *
 * This is the one place the five-stop Alchely spectrum earns its keep. Every
 * competitor in the category is a single-hue product, so the spectrum is an
 * asset none of them has — but only while it means something. Its meaning is
 * provenance, and telling generated text from clinician-written text at a
 * glance is a clinical-safety property, not decoration.
 */
const AiBadge: React.FC<AiBadgeProps> = ({
  label,
  size = "sm",
  className,
  ...rest
}) => (
  <span
    className={cn(
      "ai-spectrum-fill inline-flex items-center gap-1.5 rounded-full font-semibold",
      size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm",
      className
    )}
    {...rest}
  >
    <Sparkles aria-hidden="true" className={size === "sm" ? "size-3" : "size-3.5"} />
    {label}
  </span>
);

export default AiBadge;
